import { render, staticRenderFns } from "./ModalAShell.vue?vue&type=template&id=be2ed66c"
import script from "./ModalAShell.vue?vue&type=script&lang=js"
export * from "./ModalAShell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports